<template>
  <div>
    <list-items
      v-if="items"
      v-slot="{ item }"
      :items="items"
      :empty-text="emptyText"
      :cssClass="cssClass"
    >
      <slot :item="item">{{ item }}</slot>
    </list-items>

    <!--
    <div v-else-if="error" class="message _error">
      Ошибка: {{ error.message }}
    </div>
    
    <loader-dots v-if="loading" />
-->
  </div>
</template>

<script>
import ListItems from './ListItems';
import LoaderDots from '@@/shared/loaders/LoaderDots';

export default {
  components: {
    ListItems,
    LoaderDots
  },

  props: {
    items: {
      type: Array,
      required: true
    },
    emptyText: {
      type: String,
      default: 'Нет данных'
    },
    cssClass: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    // loading: false,
    // error: null
  })
};
</script>
